
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.427 3.432V1.678A3.1 3.1 0 011.475.936c.408-.18.813-.272 1.215-.278.489-.006.876.058 1.16.195.285.13.622.29 1.011.482.365.186.678.34.937.464.266.124.628.185 1.086.185.402 0 .795-.105 1.178-.315.39-.21.73-.501 1.02-.872V2.55c-.29.316-.627.563-1.01.742a2.75 2.75 0 01-1.179.27c-.458 0-.82-.06-1.085-.177-.26-.123-.572-.278-.937-.464-.39-.191-.73-.352-1.02-.482-.285-.13-.672-.195-1.16-.195-.403 0-.808.105-1.216.316-.408.21-.758.5-1.048.872zM.417 7.3V5.547a3 3 0 011.049-.733c.408-.18.813-.272 1.215-.278.489-.007.875.058 1.16.194.284.13.621.291 1.011.483.365.185.677.34.937.464.266.117.628.176 1.086.176.402 0 .794-.105 1.178-.315.39-.21.73-.501 1.02-.872v1.762a3.2 3.2 0 01-1.011.742c-.383.18-.776.27-1.178.27-.458 0-.82-.06-1.086-.177a41.17 41.17 0 01-.937-.464c-.39-.191-.73-.352-1.02-.482-.285-.13-.671-.195-1.16-.195-.402 0-.807.105-1.215.316A3.056 3.056 0 00.417 7.3z","fill":"#6E6B7B"}})])
          )
        }
      }
    